import { useRef } from "react";
import { useScroll, useTransform, motion } from "framer-motion";
import { Award } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SectionTag } from "../components/SectionLabel";

const PALESTRA_IMG =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_advocacy-reimagined/artifacts/6fdcepdm_Carol%20palestra.JPG";
const ROSA_WEBER_IMG =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_advocacy-reimagined/artifacts/xc2777ap_Carol%20e%20Ministra%20Rosa%20Weber.jpg";

export const AuthorityProof = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], [40, -40]);
  const y2 = useTransform(scrollYProgress, [0, 1], [-20, 20]);

  return (
    <section ref={ref} className="bg-brown-dark py-24 lg:py-32 overflow-hidden" data-testid="authority-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <SectionTag icon={Award} label="Presença e repertório" tone="teal" />
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-cream max-w-xl mb-6">
            Fora do escritório, a mesma dedicação.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-base text-cream/70 max-w-md mb-16">
            Palestras, treinamentos e presença em espaços institucionais — para
            levar clareza também para fora do escritório.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-5 gap-6 lg:gap-10 items-center">
          <motion.div style={{ y: y1 }} className="md:col-span-3 relative">
            <div className="relative aspect-[3/2] overflow-hidden">
              <img
                src={PALESTRA_IMG}
                alt="Palestra sobre direito do trabalho"
                className="w-full h-full object-cover"
                data-testid="authority-image-palestra"
              />
            </div>
            <span className="absolute -bottom-4 left-6 bg-cream border border-line px-4 py-2 font-mono text-[11px] uppercase tracking-[0.1em] text-ink-soft">
              Palestra — Compliance Trabalhista
            </span>
          </motion.div>

          <motion.div style={{ y: y2 }} className="md:col-span-2 relative mt-10 md:mt-0">
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src={ROSA_WEBER_IMG}
                alt="Ana Carolina Martins com a Ministra Rosa Weber"
                className="w-full h-full object-cover"
                data-testid="authority-image-rosa-weber"
              />
            </div>
            <span className="absolute -bottom-4 -left-4 bg-teal text-cream px-4 py-2 font-mono text-[11px] uppercase tracking-[0.1em]">
              Com a Ministra Rosa Weber
            </span>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
